var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPomIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "POMIcon_svg__a",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "POMIcon_svg__b",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 10.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#2175D9",
    xlinkHref: "#POMIcon_svg__a"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "POMIcon_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#POMIcon_svg__b"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#POMIcon_svg__c)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.75 7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.336 38.378a3.23 3.23 0 014.219-1.739A3.205 3.205 0 017.3 40.838C6.621 42.481 0 50 0 50s.655-9.988 1.336-11.622z",
    fill: "#FFB511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 9.84L10.917 4.077a23.97 23.97 0 00-8.384 10.448 23.921 23.921 0 00-1.1 15.152c0 .008.008.026.008.034v.01l-.62 1.486c-.34.817.052 1.755.873 2.094l4.472 1.843 4.472 1.843a1.616 1.616 0 002.105-.87l.62-1.486s.008 0 .008-.008c.01-.009.018-.009.027-.018a24.007 24.007 0 009.99-11.491A23.722 23.722 0 0024.9 9.84z",
    fill: "#F7F5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 9.84A24.138 24.138 0 0020.804 0a24.377 24.377 0 00-9.887 4.077L24.9 9.84z",
    fill: "#E74536"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#0F1941",
    transform: "rotate(-67.5 14.613 14.877)",
    cx: 14.613,
    cy: 14.877,
    rx: 4.819,
    ry: 4.835
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E74536",
    transform: "rotate(-67.5 14.613 14.877)",
    cx: 14.613,
    cy: 14.877,
    rx: 3.219,
    ry: 3.229
  }))))));
}
export default "data:image/svg+xml;base64,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";
export { SvgPomIcon as ReactComponent };